import { useSelector } from 'react-redux'

export default function useTileLoading() {
  const { loadedTiles, loadingTiles } = useSelector((state) => state.mapStates)
  return { isTileLoading: loadedTiles !== loadingTiles }
}
